import { IconPropsType, SwitchProps } from "../../types";

export const Switch = ({ value, handleChange, options, wrapperClassName, labelClassName = '', switchClassName = '', id, label }: SwitchProps) => {
    return (
        <div className={wrapperClassName}>
            <label
                htmlFor={id}
                className={"block text-sm font-semibold text-gray-700 " + labelClassName}
            >
                {label}
            </label>
            <div
                id={id}
                className={"flex flex-row border border-blue-200 rounded-md p-1 mt-2 w-full focus:outline-none bg-blue-50 placeholder-gray-700 h-[49.5px] relative " + switchClassName}
            >
                {options.map(o => {
                    const Icon = o.icon;
                    return (
                        <button
                            key={o.value}
                            className={`rounded-lg p-2 flex-1 h-fit flex justify-center items-center transition-all duration-500 ease-in-out ${value === o.value
                                ? 'bg-blue-500 text-white'
                                : 'text-gray-600 bg-transparent'
                                }`}
                            onClick={handleChange(o.value)}
                        >
                            {Icon && <Icon additionalStyle="mr-2" />}
                            {o.label}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}